export class Option<T> {
  value: T;
  title: string;

  constructor(value: T, title: string) {
    this.value = value;
    this.title = title;
  }
}
